<div id="bank-payment-container" class="container">
  <h2 *ngIf="payment_method_model.id">Update a Payment Account</h2>
  <h2 *ngIf="!payment_method_model.id">Add a Payment Account</h2>

  <div class="row">
    <div class="col-md-3 col-sm-4">
      <app-payments-menu></app-payments-menu>
    </div>
    <div class="col-md-9 col-sm-8">
      <div class="row">
        <div class="col-md-6">
          <mat-card appearance="outlined">
            <form [formGroup]="form" (ngSubmit)="submit()">
              <mat-card-title *ngIf="!payment_method_model.id">Add Checking Account</mat-card-title>
              <mat-card-title *ngIf="payment_method_model.id">Edit Checking Account</mat-card-title>
              <p>
                Customers MUST use a checking account, not a savings account.
              </p>
              <mat-card-content>
                <div class="input-cell">
                  <mat-form-field>
                    <mat-label>Account Holder Name</mat-label>
                    <input matInput type="text" formControlName="ch_name_on_check" />
                  </mat-form-field>
                </div>
                <div class="input-cell">
                  <mat-form-field>
                    <mat-label>Account Number</mat-label>
                    <input matInput type="text" pattern="^[0-9]+[0-9]*$" formControlName="ch_number_mask" (blur)="onBlurPlaceholder()" (keydown)="onKeyDown($event)"
                    (focus)="onFocusPlaceholder()" [maxLength]="17"/>
                  </mat-form-field>
                </div>
                <div class="input-cell">
                  <mat-form-field>
                    <mat-label>Routing Number</mat-label>
                    <input matInput type="text" formControlName="ch_transit_mask"
                           [mask]="edit ? '000000000' : ''" />
                  </mat-form-field>
                </div>
                <div class="input-cell">
                  <mat-form-field>
                    <mat-label>Bank Name</mat-label>
                    <input matInput type="text" required formControlName="ch_bank_name" [matAutocomplete]="bankNameAuto" />
                    <mat-progress-spinner *ngIf="routing_bank_name_loading" matSuffix mode="indeterminate" [diameter]="18"></mat-progress-spinner>
                    <mat-autocomplete #bankNameAuto="matAutocomplete">
                      <ng-container *ngIf="bank_name_options$ | async as bankNames">
                        <mat-option *ngIf="bank_name_loading" disabled>
                          <div class="bank-name-loading-option">
                            <mat-progress-spinner mode="indeterminate" [diameter]="18"></mat-progress-spinner>
                            <span>Loading...</span>
                          </div>
                        </mat-option>
                        <mat-option *ngFor="let name of bankNames" [value]="name">{{ name }}</mat-option>
                        <mat-option *ngIf="!bank_name_loading && bankNames.length === 0 && bank_name_query" disabled>No bank found.</mat-option>
                      </ng-container>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </mat-card-content>
              <p>By saving this payment method on file, you agree that this payment method can be used to pay any outstanding balance on your account per our <a href="http://www.simplebills.com/terms-of-service">Terms of Service</a>.</p>
              <div class="input-cell d-flex justify-content-center" *ngIf="!payment_method_model.id">
                <div>
                  <mat-slide-toggle formControlName="default_account" color="primary" class="mat-toggle" [checked]="true" [disabled]="!form.valid || first_payment_method">
                    Set as primary payment method
                  </mat-slide-toggle>                  
                </div>
              </div>
              <mat-card-actions class="mb-0">                
                <nexus-form-result [model]="result_model"></nexus-form-result>
                <nexus-form-result [model]="simple_validation_model"></nexus-form-result>
                <p class="mb-0"><button mat-raised-button type="submit" [disabled]="!form.valid" color="primary">Save</button></p>
              </mat-card-actions>
            </form>
          </mat-card>
        </div>
        <div class="col-md-6">
          <module-payment-method-primary [payment_methods_model]="payment_methods_model" [payment_method_model]="payment_method_model" (primaryPaymentMethodSelected)="onPrimaryPaymentMethodSelected($event)"></module-payment-method-primary>        
          <app-payment-method-delete [payment_methods_model]="payment_methods_model" [payment_method_model]="payment_method_model" [regulatory_model]="regulatory_model"></app-payment-method-delete>
          <payment-method-instructions></payment-method-instructions>
        </div>
      </div>
    </div>
  </div>